<template>
<b-row>
   <b-col cols="12" xl="12"> 
      <b-card>
        <b-form @submit.prevent="orgAdd">
          <b-row>
            <b-col>
                <b-form-group label="*Organization Name:" label-for="orgname">
                    <b-form-input maxlength="200" :class="{ 'is-invalid' : $v.form.orgname.$error }" id="orgNameField" v-model="$v.form.orgname.$model" type="text" class="form-control" placeholder="Enter Organization Name"  aria-describedby="orgNameField" />
                    <b-form-invalid-feedback id="orgNameField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="*Organization Billing City:" label-for="orgbillingcity">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.orgbillingcity.$error }" id="input1orgbillingcity" v-model="$v.form.orgbillingcity.$model" type="text" class="form-control" placeholder="Enter Organization Billing City"   aria-describedby="input1orgbillingcity" />
                    <b-form-invalid-feedback id="input1orgbillingcity">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="*Organization Billing State:" label-for="orgbillingstate">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.orgbillingstate.$error }" id="orgbillingstateField" v-model="$v.form.orgbillingstate.$model" type="text" class="form-control" placeholder="Enter Organization Billing State"  aria-describedby="orgbillingstateField" />
                    <b-form-invalid-feedback id="orgbillingstateField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="*Organization Billing Zip:" label-for="orgbillingzipField">
                    <b-form-input maxlength="8" :class="{ 'is-invalid' : $v.form.orgbillingzip.$error }" id="input1orgbillingcity" v-model="$v.form.orgbillingzip.$model" type="text" class="form-control" placeholder="Enter Organization Billing Zip"   aria-describedby="orgbillingzipField" />
                    <b-form-invalid-feedback id="orgbillingzipField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="*Organization Billing Country:" label-for="orgCountryField">
                    <b-form-input maxlength="40" :class="{ 'is-invalid' : $v.form.orgbillingcountry.$error }" id="orgbillingstateField" v-model="$v.form.orgbillingcountry.$model" type="text" class="form-control" placeholder="Enter Organization Billing Country"  aria-describedby="orgCountryField" />
                    <b-form-invalid-feedback id="orgCountryField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
            <b-col>
                <b-form-group label="*Organization Billing Address:" label-for="orgAddressField">
                    <b-form-input maxlength="200" :class="{ 'is-invalid' : $v.form.orgbillingaddress.$error }" id="input1orgbillingcity" v-model="$v.form.orgbillingaddress.$model" type="text" class="form-control" placeholder="Enter Organization Billing Address"   aria-describedby="orgAddressField" />
                    <b-form-invalid-feedback id="orgbillingzipField">
                       This is a required field
                    </b-form-invalid-feedback>
                </b-form-group>    
            </b-col>
          </b-row>
          <b-row>
            <b-col>

                <b-form-group label="*Org Theme Bg Color:" label-for="orgThemeBgColorField">
                    <colorpicker :color="form.orgthemebgcolor" v-model="$v.form.orgthemebgcolor.$model" />
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="*Org Theme Fg Color:" label-for="orgThemeFgColorField">
                    <colorpicker :color="form.orgthemefgcolor" v-model="$v.form.orgthemefgcolor.$model" />
                </b-form-group>   
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
                  <b-form-group label="*Select Org Type:" label-for="orgTypeField">
                      <b-form-select  :class="{ 'is-invalid' : $v.form.orgtype.$error }"  v-model="$v.form.orgtype.$model" :options="orgTypeItems"  id="orgTypeField"  aria-describedby="orgTypeField" />    
                      <b-form-invalid-feedback id="orgTypeField">
                           This is a required field
                        </b-form-invalid-feedback>
                  </b-form-group>    
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group label="Logo Image: (Only jpg,jpeg,png and gif ext allowed.)" label-for="orglogoimgField">
                  <b-form-file ref="orgLImag" @change="onFileChange"  id="orglogoimgField" accept=".jpg, .jpeg, .png, .gif" placeholder="Choose a file..."></b-form-file>
                </b-form-group>  
            </b-col>
            <b-col sm="12" md="2" v-if="previewSImage">
                <b-form-group label="Image Preview:">
                  <b-img :src="previewSImage" width="150" height="50" alt="Image Preview" />
                </b-form-group> 
            </b-col>
          </b-row>
          <b-row style="margin-top:20px;">
            <b-col cols="12">
              <b-button type="button" v-b-tooltip.hover title="Cancel" variant="secondary" @click.stop="gotolist()"  class="px-4">Cancel</b-button>
              <b-button type="submit" v-b-tooltip.hover title="Save" variant="primary"  class="px-4 pull-right">Save</b-button> 
            </b-col>
          </b-row>
        </b-form>
      </b-card>
  </b-col>
</b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate' 
import { required, maxLength } from 'vuelidate/lib/validators'
import { getResponseMessages } from '../../_helpers'
import colorPicker  from '../colorPicker.vue'
export default {
  name: 'Organization_Add',
  components: {
      'colorpicker': colorPicker
  },
  data() {
    return {
      orgTypeItems: [{
        text: 'Please select an option',
        value: '',
      }],
      fileOnjk:'',
      previewSImage:'',
      form: {
        orgname:'',
        orgtype:'',
        orgbillingcity:'',
        orgbillingstate:'',
        orgbillingzip:'',
        orgbillingcountry:'',
        orgbillingaddress:'',
        orgthemebgcolor:'',
        orgthemefgcolor:'',
        orglogoimg:''
      }
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      orgname: {
        required,
        maxLength: maxLength(200)
      },
      orgbillingcity: {
        required,
        maxLength: maxLength(40)
      },
      orgbillingstate: {
        required,
        maxLength: maxLength(40)
      },
      orgbillingzip: {
        required,
        maxLength: maxLength(8)
      },
      orgbillingcountry: {
        required,
        maxLength: maxLength(40)
      },
      orgbillingaddress: {
        required,
        maxLength: maxLength(200)
      },
      orgthemebgcolor: {
        required,
        maxLength: maxLength(40)
      },
      orgthemefgcolor: {
        required,
        maxLength: maxLength(40)
      },
      orgtype:{
        required
      }
    }  
  },
  created(){
    this.loadOrgData();
    if(this.$route.params.id != undefined){
      this.getOrgById(this.$route.params.id)
    }
  },  
  methods: {
     ...mapActions('org', ['getById','uploadData']),
    orgAdd() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return

      const formData = new FormData();
      const formObj = Object.assign({}, this.form)  
      formData.append('logoimg', this.fileOnjk) 
      Object.keys(formObj).map(function(key){ 
          formData.append(key, formObj[key])  
      })

      this.$store.dispatch('uploadData',{url:'organization/saveOrg',data: formData }).then((res) => {
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/org')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    onFileChange(e) {
      this.fileOnjk = e.target.files[0]
      if(this.fileOnjk.type == 'image/jpeg' || this.fileOnjk.type == 'image/jpg' || this.fileOnjk.type == 'image/png' || this.fileOnjk.type == 'image/gif'){
        this.previewSImage = URL.createObjectURL(e.target.files[0]);
      }else{
        this.fileOnjk = '';
        this.$refs.orgLImag.value = '';
        document.getElementById('orglogoimgField__BV_file_control_').innerHTML = 'Choose a file...';
        this.$toastr('error','Only jpg,jpeg,png and gif ext are allowed.', 'Error')
      }
      
    },
    gotolist () {
        this.$router.push('/org/list')
    },
    loadOrgData() {
      this.$store.dispatch('getById', {url:'organization/loadOrgTypeData',data :{}}).then((res) => {
        res.orgtype.forEach((version) => {
          this.orgTypeItems.push(version);
        });
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    getOrgById(id) {
      this.$store.dispatch('getById', {url:'organization/getOrgById',data : { 'orgIndex':id }}).then((res) => {
        this.form = Object.assign({}, res)  
        this.previewSImage = res.orglogoimage;
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    }
  },
}
</script>
<style type="text/css">
  .vc-chrome {
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 9;
}
.current-color {
  width: 40px;
  height: 35px;
  cursor: pointer;
}
</style>
